import type { AdminRole } from '@/lib/api-admin';

/**
 * 해외 배송비 설정 RBAC. 배송 정책은 상품/배송 운영 영역이라 상품 관리 역할과 정합.
 * (be-order 컨트롤러 @PreAuthorize 와 정합 확인 필요.)
 */
export const OVERSEAS_SHIPPING_READ_ROLES: ReadonlyArray<AdminRole> = [
  'SUPER_ADMIN',
  'OPS_ADMIN',
  'MD_MANAGER',
];

export const OVERSEAS_SHIPPING_WRITE_ROLES: ReadonlyArray<AdminRole> = [
  'SUPER_ADMIN',
  'OPS_ADMIN',
];
